
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [Themeable],
})
export default class SyncGroupDatabasesDialog extends Vue {
  public visible: boolean = true;

  public destroyComponent(): void {
    this.$emit('close');
  }

  public async syncSize(): Promise<void> {
    this.$emit('syncSizes');
    this.destroyComponent();
  }
}
